import React from 'react';
import styles from "./progress-bar.module.scss";


const ProgressBar = ({name, value}) => {

    return (
        <div className={styles.progressBarWrapper}>
            <div className="row">
                <div className="col">{name}</div>
                <div className={`col-auto ${styles.valueCol}`}>{value}</div>
            </div>
            <div className={styles.progressBar}>
                <div className={styles.progress} style={{"width": value + "%"}}></div>
            </div>
        </div>
    );
  };
  
  export default ProgressBar;